import type { ReactNode } from "react";

/** Bolds the first occurrence of `query` inside `text` — shared by the
 *  app's search autocompletes (listings, specialists) so the matched
 *  letters stand out the same way everywhere. */
export function highlightMatch(text: string, query: string): ReactNode {
  const q = query.trim();
  if (!q) return text;
  const idx = text.toLowerCase().indexOf(q.toLowerCase());
  if (idx === -1) return text;
  return (
    <>
      {text.slice(0, idx)}
      <mark className="rounded bg-indigo-100 text-indigo-700 not-italic">
        {text.slice(idx, idx + q.length)}
      </mark>
      {text.slice(idx + q.length)}
    </>
  );
}
